// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lote-label {
  font-size: 10px;
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 2px 4px;
  border-radius: 3px;
  color: black;
  border: 1px solid #ccc;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
}


.quadra-label {
  font-size: 10px;
  font-weight: bold;
  background-color: rgba(194, 193, 192, 0.733);
  padding: 2px 4px;
  border-radius: 3px;
  color: black;
  border: none;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
  top: -20px;
  z-index: 2;
}

.nucleo-label {
  font-size: 10px;
  font-weight: bold;
  background-color: rgba(255, 128, 69, 0.7);
  padding: 2px 4px;
  border-radius: 3px;
  color: black;
  border: none;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
  top: 10%;
  z-index: 3;
}

.territorio-label::before {
  display: none;
}

.territorio-label {
  visibility: hidden;
  font-size: 10px;
  font-weight: bold;
  background-color: transparent;
  box-shadow: none;
  padding: 2px 4px;
  border-radius: 3px;
  color: #ffffff;
  /* text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0,0,0,0.6); */
  border: none;
  white-space: nowrap;
  text-align: center;
  pointer-events: none;
  z-index: 3;
}

.show-territory-labels .territorio-label {
  visibility: visible;
}
/* Container do seletor de mapa base */
.base-map-selector {
  position: absolute;
  bottom: 45px;
  right: 25px;
  z-index: 1000;
  width: 100px;
  font-size: 12px;
  background: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

/* Estilo da div central com o nome */


/* Painel de informações */
.feature-info-panel {
  position: absolute;
  bottom: 20px;
  right: 10px;
  z-index: 1000;
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  max-width: 300px;
  max-height: 400px;
  overflow: auto;
  font-family: Arial, sans-serif;
  font-size: 12px;
}

.feature-info-panel button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.feature-info-panel h3 {
  margin-top: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.feature-info-panel div > div {
  margin-bottom: 8px;
}

/* Container do mapa (ajuste se necessário) */
.map-container {
  height: 100%;
  width: 100%;
}

.map-details-loading {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border: 1px solid rgba(25, 118, 210, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.16);
  color: #3f4b57;
  font: 500 12px Arial, sans-serif;
  pointer-events: none;
}

.map-details-loading__spinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(25, 118, 210, 0.22);
  border-top-color: #1976d2;
  border-radius: 50%;
  animation: map-details-loading-spin 0.75s linear infinite;
}

@keyframes map-details-loading-spin {
  to { transform: rotate(360deg); }
}

`, "",{"version":3,"sources":["webpack://./src/components/styles/MapComponent.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,wEAAwE;EACxE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,qCAAqC;;;AAGrC,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,oBAAoB;EACpB,qCAAqC;EACrC,yCAAyC;EACzC,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".lote-label {\n  font-size: 10px;\n  font-weight: bold;\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 2px 4px;\n  border-radius: 3px;\n  color: black;\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  text-align: center;\n  pointer-events: none;\n}\n\n\n.quadra-label {\n  font-size: 10px;\n  font-weight: bold;\n  background-color: rgba(194, 193, 192, 0.733);\n  padding: 2px 4px;\n  border-radius: 3px;\n  color: black;\n  border: none;\n  white-space: nowrap;\n  text-align: center;\n  pointer-events: none;\n  top: -20px;\n  z-index: 2;\n}\n\n.nucleo-label {\n  font-size: 10px;\n  font-weight: bold;\n  background-color: rgba(255, 128, 69, 0.7);\n  padding: 2px 4px;\n  border-radius: 3px;\n  color: black;\n  border: none;\n  white-space: nowrap;\n  text-align: center;\n  pointer-events: none;\n  top: 10%;\n  z-index: 3;\n}\n\n.territorio-label::before {\n  display: none;\n}\n\n.territorio-label {\n  visibility: hidden;\n  font-size: 10px;\n  font-weight: bold;\n  background-color: transparent;\n  box-shadow: none;\n  padding: 2px 4px;\n  border-radius: 3px;\n  color: #ffffff;\n  /* text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5), 0 0 1px rgba(0,0,0,0.6); */\n  border: none;\n  white-space: nowrap;\n  text-align: center;\n  pointer-events: none;\n  z-index: 3;\n}\n\n.show-territory-labels .territorio-label {\n  visibility: visible;\n}\n/* Container do seletor de mapa base */\n.base-map-selector {\n  position: absolute;\n  bottom: 45px;\n  right: 25px;\n  z-index: 1000;\n  width: 100px;\n  font-size: 12px;\n  background: white;\n  padding: 5px;\n  border-radius: 5px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Estilo da div central com o nome */\n\n\n/* Painel de informações */\n.feature-info-panel {\n  position: absolute;\n  bottom: 20px;\n  right: 10px;\n  z-index: 1000;\n  background-color: white;\n  padding: 15px;\n  border-radius: 8px;\n  max-width: 300px;\n  max-height: 400px;\n  overflow: auto;\n  font-family: Arial, sans-serif;\n  font-size: 12px;\n}\n\n.feature-info-panel button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.feature-info-panel h3 {\n  margin-top: 0;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n}\n\n.feature-info-panel div > div {\n  margin-bottom: 8px;\n}\n\n/* Container do mapa (ajuste se necessário) */\n.map-container {\n  height: 100%;\n  width: 100%;\n}\n\n.map-details-loading {\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 10px;\n  border: 1px solid rgba(25, 118, 210, 0.18);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.16);\n  color: #3f4b57;\n  font: 500 12px Arial, sans-serif;\n  pointer-events: none;\n}\n\n.map-details-loading__spinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(25, 118, 210, 0.22);\n  border-top-color: #1976d2;\n  border-radius: 50%;\n  animation: map-details-loading-spin 0.75s linear infinite;\n}\n\n@keyframes map-details-loading-spin {\n  to { transform: rotate(360deg); }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
